import React, { useState, useEffect, useContext } from 'react';
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';

const AdministrativeOutwards = () => {
  const context = useContext(AdminContext);
  const { GetAdministativeoutwards } = context;


  const [technicalInwards, setTechnicalInwards] = useState([])
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [proposallist, setProposalList] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState('');
  const budgetEstimation = proposallist;

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const getProjectList = async () => {
    let data = await GetAdministativeoutwards();
    setTechnicalInwards(data)
    setProposalList(data)
  };

  useEffect(() => {
    getProjectList();
  }, []);

  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = technicalInwards.filter(bill =>
      Object.values(bill).some((val) =>
        (val || '').toString().toLowerCase().includes(lowerSearchTerm)
      )
    );
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [searchTerm, technicalInwards]);



  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter(item => item.AdminApprovalID == BillID)
      .map(item => ({
        "Government Approval Number": item.GovernmentApprovalNumber,
        "Government Order Number": item.GovernmentOrderNo,
        "Head Code": item.HeadCode,
        "GR UID": item.GRUID,
        "Finance Year": item.AdminApprovalYear,
        "District": item.District,
        "Taluka": item.Taluka,
        "Amount": item.Amount,
        "Government Approval Date": new Date(item.GovernmentApprovalDate).toLocaleString(),
        "Government Order Date": new Date(item.GovernmentOrderDate).toLocaleString(),
        "Government Order End Date": new Date(item.GovernmentOrderDate).toLocaleString(),
        "Administrative Approval Copy": item.AdminApprovalCopy,
        "Date": new Date(item.created_At).toLocaleString(),
      }));


    console.log("------------------", result)
    setSelectedProposal(result[0]);
  }

  return (
    <>

      <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
        <div className="col-11 m-auto">
          <div className="col-12 ">
            <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h5 className='my-auto fw-bold'>
                <img src="/Progress-Report64.png" alt="Progress Report" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                <span className='my-auto '>Administrative Approval Outward</span>
              </h5>
              <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                <img
                  src="/Search32.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    width: "16px",
                    height: "16px",
                    opacity: 0.6
                  }}
                />
                <input
                  type="text"
                  placeholder="Search Here"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                  style={{
                    width: "100%",
                    padding: "8px 12px 8px 32px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#f1f6fc",
                    fontSize: "14px",
                    color: "#333",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    outline: "none"
                  }}
                />
              </div>
            </div>

            <div className="col-12 pb-5">
              <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "70rem" }}>

                <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                  <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ color: 'white', border: 'none', height: '2rem' }}>

                        <th style={headerStyle} rowSpan={2} colSpan={1}>Government Approval Number</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Government Order Number</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Head Code</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>GR UID</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Technical UID</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Finance Year</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>District</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Taluka</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Amount</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Government Approval Date</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Government Order Date</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Government Order End Date</th>
                        <th style={headerStyle} rowSpan={2} colSpan={1}>Administrative Approval Copy</th>
                        <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>Date</th>
                        <th style={headerStyle} colSpan={4}>Approved by</th> {/* changed from 9 to 7 */}
                        {/* <th style={{ width: "15%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>show</th> */}
                      </tr>
                      <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
                        <th style={headerStyle}>Department HOD(EE)</th>
                        <th style={headerStyle}>Finance Department Auditor</th>
                        <th style={headerStyle}>CAFO</th>
                        <th style={headerStyle}>Additional CEO</th>
                      </tr>
                    </thead>

                    <tbody >
                      {currentBills?.length === 0 ? (
                        <tr>
                          <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                            No data available
                          </td>
                        </tr>
                      ) : (
                        currentBills?.map((proposal, index) => {
                          const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                          return (
                            <tr style={{ backgroundColor: bgColor }} key={index}>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.GovernmentApprovalNumber}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.GovernmentOrderNo}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.HeadCode}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.GRUID}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.TechnicalUID}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.AdminApprovalYear}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.District}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.Taluka}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.Amount}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{new Date(proposal.GovernmentOrderDate).toLocaleString()}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{new Date(proposal.GovernmentOrderDate).toLocaleString()}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{new Date(proposal.GovernmentOrderDate).toLocaleString()}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.AdminApprovalCopy}</td>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{new Date(proposal.created_At).toLocaleString()}</td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance1 === 'true' ? (
                                  <div className='m-auto'
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '6px',
                                      backgroundColor: '#16C60C',
                                      border: 'none',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      fontSize: '13px',
                                      color: 'white',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                  >
                                    ✓
                                  </div>
                                ) : proposal.Approvance1 === 'false' ? (
                                  <div
                                    className='m-auto'
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '6px',
                                      backgroundColor: '#dc2626',
                                      border: 'none',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      fontSize: '13px',
                                      color: 'white',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                  >
                                    ✕
                                  </div>
                                ) : '-'}
                              </td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance2 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance3 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance3 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance4 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance4 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>

                              {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                              {/* <td>
                            <button
                              className='m-auto'
                              onClick={() => selectedBillDetails(proposal.AdminApprovalID)}
                              style={{
                                cursor: 'pointer',
                                background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                color: 'white',
                                border: 'none',
                                padding: '8px 20px',
                                borderRadius: '4px',
                                fontSize: "12px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: 'center'
                              }}
                            >
                              <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
                              View
                            </button>
                          </td> */}
                            </tr>

                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='col-12 mt-4'>
                  <div className="row">
                    <div className='col-6'>
                      <p>Showing {currentBills?.length} to {Math.min(indexOfLastBill, proposallist?.length)} of {proposallist?.length} entries</p>
                    </div>
                    <div className='col-6 text-end' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                      <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px' }}>&laquo;</button>
                      <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&lt;</button>
                      <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', border: '1px solid lightgrey', borderLeft: "none" }}>
                        {currentPage}
                      </button>
                      <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&gt;</button>
                      <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&raquo;</button>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
          {
            selectedProposal && (
              <div
                onClick={() => setSelectedProposal(null)}
                style={{
                  position: 'fixed',
                  top: 0, left: 0,
                  width: '100vw',
                  height: '100vh',
                  backgroundColor: 'rgba(0, 0, 0, 0.84)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 9999
                }}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    backgroundColor: 'white',
                    padding: '40px 40px',
                    borderRadius: '20px',
                    width: '50%',
                    maxHeight: '90vh',
                    overflow: "hidden",
                    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                    position: 'relative'
                  }}
                >

                  <div className="col-12">

                    <div className="col-12  mb-3">
                      <div className="row">
                        <div className="col-6">
                          <h5 className='fw-bold'>Approval Details</h5>
                        </div>

                        <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <button
                            onClick={() => setSelectedProposal(null)}
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: 'red',
                              border: 'none',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: "center",
                              cursor: 'pointer',
                              fontSize: '24px',
                              fontWeight: 'bold',
                              color: 'white',
                              lineHeight: 1
                            }}
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
                      <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
                        <tbody>
                          {Object.entries(selectedProposal).map(([key, value], index) => (
                            <>
                              <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
                                <td style={{
                                  fontWeight: 'bold',
                                  padding: '8px',
                                  width: '40%',
                                  backgroundColor: '#2B75D5',
                                  color: 'white',
                                  border: '1px solid #cce0f9'
                                }}>
                                  {key}
                                </td>
                                <td style={{
                                  padding: '8px',
                                  color: "black",
                                  backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

                                }}>
                                  {/* Handle Upload Bill Copy link */}
                                  {key === 'Administrative Approval Copy' && value ? (
                                    <a href={`${apiurl}/AdminApprovalCopy/${value}`} target="_blank" rel="noreferrer">
                                      {value}
                                    </a>
                                  ) : value === null || value === '' ? (
                                    '-'
                                  ) : (
                                    value.toString()
                                  )}
                                </td>

                              </tr>

                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>

                  </div>

                </div>
              </div>
            )}
        </div>
      </div>




    </>
  );
};

export default AdministrativeOutwards;
